import { useState } from "react"

export default function ToggleGroup({ value, onChange, leftOption, rightOption, className }) {
    const [selectedOption, setSelectedOption] = useState(value)

    const handleChange = (newValue) => {
        const newValLowerCase = newValue.toLowerCase()

        setSelectedOption(() => {
            onChange(null, newValLowerCase)
            return newValLowerCase
        })
    }

    const selectedClasses = 'bg-primary-blue [&_span]:text-white hover:text-white'

    return (
        <div className={`bg-tertiary-blue text-sm leading-none border-2 rounded-full inline-flex p-1 font-['Nunito'] font-semibold ${className}`}>
            <div data-test="toggle-group-left-option" onClick={() => handleChange(leftOption)} className={`${selectedOption === leftOption.toLowerCase() ? selectedClasses : ''} cursor-pointer w-1/2 inline-flex items-center justify-center transition-colors duration-75 ease-in focus:outline-none  focus:text-blue-400 rounded-full px-4 py-2`}>
                <span>{leftOption}</span>
            </div>
            <div data-test="toggle-group-right-option" onClick={() => handleChange(rightOption)} className={`${selectedOption === rightOption.toLowerCase() ? selectedClasses : ''} cursor-pointer inline-flex items-center transition-colors duration-75 w-1/2 ease-in focus:outline-none justify-center hover:text-blue-400 focus:text-blue-400 rounded-full px-4 py-2`}>
                <span>{rightOption}</span>
            </div>
        </div>
    )
}
